import React, { useEffect } from "react";
import { setAdminPlusRankingPoints } from "../../../utils/service/ranking";

export default function KeyOffering(props) {
  function pointAction(type) {
    setAdminPlusRankingPoints(
      type,
      props.state.user.registration,
      "c90a159e-e538-43d3-a66b-82292586912f"
    );
  }

  useEffect(() => {
    document.getElementById("title-card-optionArea").focus();
  }, []);
  return (
    <div className="div-optionArea">
      <div className="card-talent">
        <a className="title-card-talent" id="title-card-optionArea" tabIndex={13}>
          Key Offering
        </a>
        <video
          width={250}
          controls
          tabIndex={14}
          onPlay={() => pointAction("PALCO2KEYOFFERING")}
        >
          <source src="https://s3.us-east-1.amazonaws.com/bucket.aws.private/hall_83778/ACESSIBILIDADE/PALCO%202/KEY%20OFFERING/Key%20Offering%20%28Evandro%29.mp4" />
        </video>
      </div>
    </div>
  );
}
